import {createContext, useContext} from 'react';

const UserContext = createContext({
    user: null,
    setUser: user => {}
});
export default UserContext;

const useCurrentUser = () => {
    return useContext(UserContext)
}
export {useCurrentUser}